// extracted by mini-css-extract-plugin
module.exports = {"root":"Stepper-module--root--3w-vX","stepperTitle":"Stepper-module--stepperTitle--3k0bp"};